import React from 'react';
import './LoadingSpinner.css';

// minHeight should match (or closely approximate) the height of whatever
// lazy-loaded section this stands in for, so the swap from spinner to real
// content doesn't shift anything else on the page (CLS).
function LoadingSpinner({ minHeight = 200, label = 'Loading...' }) {
  return (
    <div className="spinner-container" style={{ minHeight }}>
      <div className="spinner"></div>
      <p>{label}</p>
    </div>
  );
}

export default LoadingSpinner;